import { EditorStep } from '@/features/product-editor/components/EditorComponents/EditorStep';
import { PRODUCT_TYPES } from '@/lib/constants';
import { useMemo } from 'react';
import { usePageDataStore } from '@/features/product-editor/pageStore';
import { ProductType } from '@/types/store';
import FormFields from './EditorComponents/FormFields/FormFields';

const SECTIONS: Record<
    string,
    {
        id: string;
        title: string;
        component: React.ReactNode;
        exludedProducts?: ProductType[];
        includedProducts?: ProductType[];
    }
> = {
    IMAGE: {
        id: 'IMAGE',
        title: 'Select Image',
        component: <h1>Select Product Image</h1>,
        exludedProducts: [PRODUCT_TYPES.LEAD_MAGNET],
    },
    DESCRIPTION: {
        id: 'DESCRIPTION',
        title: 'Write Description',
        component: <h1>Description</h1>,
        exludedProducts: [PRODUCT_TYPES.LEAD_MAGNET],
    },
    PRICE: {
        id: 'PRICE',
        title: 'Set price',
        component: <h1>Price</h1>,
        exludedProducts: [PRODUCT_TYPES.LEAD_MAGNET],
    },
    COLLECT_INFO: {
        id: 'COLLECT_INFO',
        title: 'Collect info',
        component: <FormFields />,
        exludedProducts: [PRODUCT_TYPES.LEAD_MAGNET],
    },
    ATTACHMENTS: {
        id: 'ATTACHMENTS',
        title: 'Attachments',
        component: <h1>Attachments</h1>,
        includedProducts: [PRODUCT_TYPES.LEAD_MAGNET, PRODUCT_TYPES.DIGITAL_DOWNLOAD],
    },
};

export default function ProductSection() {
    const { pageData } = usePageDataStore();

    const pageType = pageData.product.type;

    // Filter sections to show based on page type
    const sectionsToShow = useMemo(() => {
        return Object.values(SECTIONS).filter(section => {
            let include = true;
            if (section.exludedProducts) {
                include = include && !section.exludedProducts.includes(pageType);
            }
            if (section.includedProducts) {
                include = include && section.includedProducts.includes(pageType);
            }
            return include;
        });
    }, [pageType]);

    return (
        <div>
            {sectionsToShow.map((section, index) => (
                <div key={section.id}>
                    <EditorStep number={index + 1} title={section.title}>
                        {section.component}
                    </EditorStep>
                </div>
            ))}
        </div>
    );
}
